<ui-form [config]="reportsFormConfig" [useAutoSave]="false" (inputChange)="onFormChange($event)">
</ui-form>